const isName = (name: string) => {
  const length = name.replace(/\.eth$|.lens$/, "").length
  return length >= 3 && !name.includes(" ")
}

export const isQualifiedEvmName = (name: string) =>
  isName(name) &&
  [".eth", ".dcl.eth", ".lens"].some(domain => name.endsWith(domain))
